<template>
<v-container style="min-height:100%">
  <v-dialog v-model="dialog" persistent width="400" v-if="!loading && !isProcessing && !error && !success">
    <v-card>
      <v-card-text v-if="userId" class="text-xs-center mb-0">
        <v-avatar :size="64" class="mx-2 my-2"><img :src="userAvatar"></img></v-avatar>
        <p class="subheading font-weight-bold">{{userMail}}</p>
      </v-card-text>
      <v-card-text>
        <p class="subheading">{{ $t('join.welcome',{name:$appName}) }}</p>
        <p v-if="userId" v-html="$t('join.welcome_description',{name:$appName})"></p>
        <p v-if="!userId" v-html="$t('join.sign_in_required')"></p>
        <p v-if="!userId" v-html="$t('join.workaround_google_sign_in')"></p>
      </v-card-text>
      <v-card-actions>
        <v-btn large flat @click="changeAccount" color="secondary" v-if="userId">{{ $t('join.change_account') }}</v-btn>
        <v-btn large flat @click="copy" color="secondary" v-else>{{ $t('join.copy_link') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn large flat @click="login" color="primary" v-if="!userId">{{ $t('join.sign_in') }}</v-btn>
        <v-btn large flat @click="join" color="primary" v-if="userId">{{ $t('join.join_now') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <span class="centerized title grey--text text-xs-center" v-if="error">{{ error }}</span>

  <span class="centerized title success--text text-xs-center" v-if="success">{{ success }}</span>

  <progress-dialog :visible="isProcessing">{{ $t('join.joining') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'TubeJoin',
  mixins: [UserAuth],
  data: () => ({
    loading: true,
    md5: null,
    error: null,
    isProcessing: false,
    success: null,
    dialog: true
  }),
  methods: {
    login() {
      this.$router.replace('/login?redirect=' + encodeURIComponent(this.$route.fullPath));
    },
    changeAccount() {
      this.$auth.signOut();
      this.login();
    },
    async join() {
      this.isProcessing = true;
      let ref = this.$db.ref('userTubeAuth').child(this.userId);
      await ref.remove();
      await ref.set(this.md5);
      ref.on('value', async (snapshot) => {
        let val = snapshot.val();
        if (val === this.md5) {
          return;
        } else if (val === 'invalid') {
          await snapshot.ref.off();
          await snapshot.ref.remove();
          this.error = this.$t('join.invalid_auth');
        } else {
          await snapshot.ref.off();
          await snapshot.ref.remove();
          this.success = this.$t('join.join_success');
        }
        this.isProcessing = false;
      });
    },
    async copy() {
      try {
        await this.$copyText(window.location.href);
        this.$emit('toast', this.$t('join.link_copied'));
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    let md5 = this.$route.params.clientId;
    if (!md5) {
      this.error = this.$t('join.invalid_auth');
    } else {
      this.md5 = md5;
    }
    this.loading = false;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/TubeJoin.vue